import React, { useEffect } from 'react';
import { toggleScrollLock } from 'helpers';
import { Overlay, OverlaySpinner } from './styled';

const LoadingOverlay = ({
  isLoading,
  variant = 'global',
  size,
  scrollLock,
  comment,
  isFullscreen,
  roundedCorners,
  ...props
}: Props) => {
  useEffect(() => {
    if (scrollLock) toggleScrollLock(isLoading);
    return () => {
      if (scrollLock) toggleScrollLock(false);
    };
  }, [isLoading, scrollLock]);

  if (isLoading) {
    return (
      <Overlay
        variant={variant}
        scrollLock={scrollLock}
        isFullscreen={isFullscreen}
        roundedCorners={roundedCorners}
        {...props}
      >
        <OverlaySpinner size={size} variant={variant === 'light' ? 'dark' : 'light'} />
        {comment && <p>{comment}</p>}
      </Overlay>
    );
  }

  return null;
};

type Props = {
  isLoading: boolean;
  variant: LoadingOverlayVariants;
  className?: string;
  size?: string;
  scrollLock?: boolean;
  comment?: string;
  isFullscreen?: boolean;
  roundedCorners?: boolean;
};

export type LoadingOverlayVariants = 'light' | 'dark' | 'global' | 'black';

export default LoadingOverlay;
